"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var makeStyle = function makeStyle()
/*{globalVariables={}}={}*/
{
  return {
    Label: {
      marginTop: 9,
      height: 32
    }
  };
};

var _default = makeStyle;
exports["default"] = _default;
//# sourceMappingURL=style.js.map